import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { useDispatch } from 'react-redux'
import { appAllGetFacilityBooking } from '../../store/facilitybooking'
import { facilityBookingExportColumns } from '../../config/exportColumns/facilityBookingExportColumns'

function FacilityBooking() {
	const dispatch = useDispatch()
	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Facility Booking</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(appAllGetFacilityBooking({ ...params, loading: false }))
							}
							filters={{}}
							columns={facilityBookingExportColumns}
							fileName="Facility Bookings"
							sheetName="Facility Booking List"
							buttonText="Export Facility Bookings"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default FacilityBooking
